import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { putRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import messages from 'src/pages/TutorialDetailsPage/messages';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';
import {
  buildSaveTutorialOptionParams,
  type QuestionOptionParamsType,
} from './useCreateQuestionOption';

type UpdateQuestionOptionParamsType = QuestionOptionParamsType & {
  questionUuid: string;
  optionUuid: string;
};

const updateQuestionOption = async (
  questionOption: UpdateQuestionOptionParamsType,
) => {
  const { data } = await putRequest<RequestSimplifiedData>(
    API.PUT.updateQuestionOption(
      questionOption.questionUuid,
      questionOption.optionUuid,
    ),
    buildSaveTutorialOptionParams(questionOption),
  );

  return data;
};

export const useUpdateQuestionOption = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: updateQuestionOption,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.tutorialOptionSaved), 1000);
      client.invalidateQueries({ queryKey: [QUERY_KEYS.TUTORIAL_QUESTIONS] });
    },
    onError: handleError,
  });
};
